import React, { useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, Card, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";

const Stakeholder = ({company_id}) => {
    const user_id = company_id;

  const downloadLinkRef = useRef(null);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_API;
  const [stackholders, setstackholders] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [isDisable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);



  const initialFormState = {
    family_name: "",
    given_name: "",
    percentage_of_ownership: "",
    role_as_director: "",
    position: "",
    is_authorised_signatory: "",
    type_of_signing_authority: "",
    government_id: "",
    date_of_birth: "",
    passport_number: "",
    passport_issue_date: "",
    passport_expiry_date: "",
    issued_by: "",
    resident_of_baharain: "",
    bararin_residence_permit_number: "",
    bararin_residence_permit_expiry_date: "",
    passport_first: null,
    passport_last: null,
    cpr_front: null,
    cpr_back: null,
    reslidence_permit_certificate: null,
    authorized_signatory_proof: null,
  };

  const [blacklistednames, setBlackListedNames] = useState({});

  useEffect(() => {
    const fetchBlackListedNames = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/blacklisted-names`);
        
        // Assuming response.data is an array of objects with a "name" field
        const namesArray = response.data.map(item => item.name); // Extract names
  
        // Convert array of names to object with names as keys
        const namesObject = namesArray.reduce((acc, name) => {
          acc[name] = true;
          return acc;
        }, {});
  
        // Update state with the names object
        setBlackListedNames(namesObject);
        
        // Logging to verify the format
        console.log("Blacklisted Names Object:", namesObject);
      } catch (error) {
        console.error("Error fetching blacklisted names:", error);
      }
    };
  
    fetchBlackListedNames();
  }, [BaseUrl]);



  const mapStakeholdersWithBlacklist = (stakeholders, blacklistednames) => {
    return stakeholders.map(stakeholder => {
      const isBlackListed = 
      blacklistednames[stakeholder.family_name] || 
      blacklistednames[stakeholder.given_name];
      return {
        ...stakeholder,
        isBlackListed: !!isBlackListed, 
      };
    });
  };

  const [formState, setFormState] = useState(initialFormState);

  useEffect(() => {
    const fetchstackholders = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${BaseUrl}/getStackholderAdmin`, {
          user_id,
        });
        setLoading(false);
        const stakeholdersData = response.data;

        // Map the stakeholders with the blacklist info
        const updatedStakeholders = mapStakeholdersWithBlacklist(stakeholdersData, blacklistednames);

        setstackholders(updatedStakeholders);
        // If stackholders has data, fill the form and disable it
        if (response.data.length > 0) {
          setFormState(response.data[0]);
          setEditingIndex(0); // Disable editing
          setDisable(true);
        }
      } catch (error) {
        console.log(error.message || "Error fetching bank accounts");
      }
    };

    fetchstackholders();
    // eslint-disable-next-line
  }, [BaseUrl, blacklistednames]);



  const handleDeleteStackHolder = (index) => {
    setstackholders((prevStackholders) => {
      const updatedStackholders = [...prevStackholders];
      updatedStackholders.splice(index, 1);
      return updatedStackholders;
    });
  };

  const handleEditStackHolder = (index) => {
    setFormState(stackholders[index]);
    setEditingIndex(index);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

 
  const [isReadOnly, setReadOnly] = useState(false);
  

  const handleDownloadStakeholder = async (filename) => {
    const queryParams = new URLSearchParams({
      company_id: user_id,
    });

    const response = await fetch(
      `${BaseUrl}/downloadStakeholderfile/${filename}?${queryParams.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.ok) {
      toast.success("File downloaded successfully.");

      // Create a temporary anchor element to trigger the download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      // Ensure downloadLinkRef.current is not null before accessing its properties
      if (downloadLinkRef.current) {
        downloadLinkRef.current.href = url;
        downloadLinkRef.current.setAttribute("download", filename);
        downloadLinkRef.current.click();
      } else {
        console.error("downloadLinkRef.current is null");
      }
    } else {
      return;
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <>

      <div className="page-content">
        <div className="container-fluid">
          {stackholders.length > 0 ? (
            <div id="completeform">
              <Row className="justify-content-center">
                <Col lg={12}>
                  <div className="stakeholder-header">
                  {stackholders.map((stakeholder, index) => (
                    <Card key={index} className="mb-3">
                      <Card.Header>
                        <h5
                          className="card-title fw-bold"
                          style={{ color: "#776ad8" }}
                        >
                          Stakeholder {index + 1}
                        </h5>
                      </Card.Header>
                      <Card.Body>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h5 className="card-title fw-bold" style={{ color: stakeholder.isBlackListed ? 'red' : 'black' }} >
                              
                              Stakeholder {index + 1} -{" "}
                              {stakeholder.family_name} {stakeholder.given_name}
                            </h5>
                            <h5 className="card-title fw-bold" style={{ color: stakeholder.isBlackListed ? 'red' : 'black' }}>
                              Position: {stakeholder.position}
                            </h5>
                          </div>
                          <div className="editDeletebtn">
                            <Button
                              variant="primary"
                              className="me-2"
                              onClick={() => handleEditStackHolder(index)}
                            >
                              {isDisable ? (
                                <i class="fa-solid fa-eye"></i>
                              ) : (
                                <i class="fa-solid fa-pen-to-square"></i>
                              )}
                            </Button>
                            <Button
                              variant="danger"
                              onClick={() => handleDeleteStackHolder(index)}
                              hidden={isDisable}
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                  </div>
                  <Col lg={12}>
                  <div id="printableArea">
                    <form id="mform">
                      <div className="row justify-content-center">
                        
                        <div className="col-lg-12">
                          <div className="card">
          
                            <div className="card-header">
                              <h4
                                className="card-title fw-bold"
                                style={{ color: "#776ad8" }}
                              >
                                Partner/Director
                              </h4>
                            </div>
                            <div className="card-body">
                              <div className="table-responsive">
                                <Table striped bordered hover>
                                  <tbody>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Full Name:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.family_name}{" "}
                                        {formState.given_name}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        % of ownership in company:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.percentage_of_ownership}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Role as a Director:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.role_as_director}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Position in the Company:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.position}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Authorised Signatory:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.is_authorised_signatory}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Type of Signing Authority:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.type_of_signing_authority}
                                      </td>
                                    </tr>
                                    {formState.pep_name ?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                      PEP Name:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.pep_name }
                                      </td>
                                    </tr>
                                    :""}
                                    {formState.position_held?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                      Position Held:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.position_held}
                                      </td>
                                    </tr>
                                    :""}
                                     {formState.relative_pep_name?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                      Name of PEP Relative / Associate:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.relative_pep_name }
                                      </td>
                                    </tr>
                                    :""}
                                    {formState.relationship_with_pep?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                      Relation With PEP:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.relationship_with_pep  }
                                      </td>
                                    </tr>
                                    :""}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Identity Section */}

                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="card-header">
                              <h4
                                className="card-title fw-bold"
                                style={{ color: "#776ad8" }}
                              >
                                Identity
                              </h4>
                            </div>
                            <div className="card-body">
                              <div className="table-responsive">
                                <Table striped bordered hover>
                                  <tbody>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        CPR / ID / SSN issued by Govt.:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.government_id}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Date of Birth:
                                      </td>
                                      <td className="col-md-8">
                                        {formatDate(formState.date_of_birth)}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Passport Number:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.passport_number}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Date of Issue:
                                      </td>
                                      <td className="col-md-8">
                                        {formatDate(
                                          formState.passport_issue_date
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Expiry Date:
                                      </td>
                                      <td className="col-md-8">
                                        {formatDate(
                                          formState.passport_expiry_date
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Country Issued By:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.issued_by}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Resident of Bahrain:
                                      </td>
                                      <td className="col-md-8">
                                        {formState.resident_of_baharain}
                                      </td>
                                    </tr>
                                    {formState.bararin_residence_permit_number?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Bahrain Residence Permit Number:
                                      </td>
                                      <td className="col-md-8">
                                        {
                                          formState.bararin_residence_permit_number
                                        }
                                      </td>
                                    </tr>
                                    :""}
                                    {formState.bararin_residence_permit_expiry_date?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Expiry Date:
                                      </td>
                                      <td className="col-md-8">
                                        {formatDate(
                                          formState.bararin_residence_permit_expiry_date
                                        )}
                                      </td>
                                    </tr>
                                    :""}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Attachments Section */}

                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="card-header">
                              <h4
                                className="card-title fw-bold"
                                style={{ color: "#776ad8" }}
                              >
                                Attachments
                              </h4>
                            </div>
                            <div className="card-body">
                              <div className="table-responsive">
                                <Table striped bordered hover>
                                  <tbody>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Passport Copy (First Page)
                                      </td>
                                      <td className="col-md-6 ">
                                        {formState.passport_first}
                                      </td>
                                      <td className="col-md-2">
                                        {formState.passport_first && (
                                          <span
                                            hidden ={isReadOnly}
                                            className="badge badge-success"
                                            onClick={() =>
                                              handleDownloadStakeholder(
                                                formState.passport_first
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              backgroundColor: "green",
                                            }}
                                          >
                                            Download
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        Passport Copy (Last Page):
                                      </td>
                                      <td className="col-md-6 ">
                                        {" "}
                                        {formState.passport_last}
                                      </td>
                                      <td className="col-md-2">
                                        {formState.passport_last && (
                                          <span
                                          hidden ={isReadOnly}
                                            className="badge badge-success"
                                            onClick={() =>
                                              handleDownloadStakeholder(
                                                formState.passport_last
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              backgroundColor: "green",
                                            }}
                                          >
                                            Download
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                    {formState.cpr_front?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        CPR Front Copy:
                                      </td>
                                      <td className="col-md-6 ">
                                        {" "}
                                        {formState.cpr_front}
                                      </td>
                                      <td className="col-md-2">
                                        {formState.cpr_front && (
                                          <span
                                          hidden ={isReadOnly}
                                            className="badge badge-success"
                                            onClick={() =>
                                              handleDownloadStakeholder(
                                                formState.cpr_front
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              backgroundColor: "green",
                                            }}
                                          >
                                            Download
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                    :""}
                                    {formState.cpr_back?
                                    <tr>
                                      <td className="col-md-4 fw-bold">
                                        CPR Back Copy:{" "}
                                      </td>
                                      <td className="col-md-6 ">
                                        {formState.cpr_back}
                                      </td>
                                      <td className="col-md-2">
                                        {formState.cpr_back && (
                                          <span
                                            hidden ={isReadOnly}
                                            className="badge badge-success"
                                            onClick={() =>
                                              handleDownloadStakeholder(
                                                formState.cpr_back
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              backgroundColor: "green",
                                            }}
                                          >
                                            Download
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                    :""}
                                    {formState?.reslidence_permit_certificate?
                                      <tr>
                                      <td className="col-md-4 fw-bold">
                                        Residence Permit Certificate:{" "}
                                      </td>
                                      <td className="col-md-6 ">
                                        {
                                          formState?.reslidence_permit_certificate
                                        }
                                      </td>
                                      <td className="col-md-2">
                                        {formState?.reslidence_permit_certificate && (
                                          <span
                                          hidden ={isReadOnly}
                                            className="badge badge-success"
                                            onClick={() =>
                                              handleDownloadStakeholder(
                                                formState.reslidence_permit_certificate
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              backgroundColor: "green",
                                            }}
                                          >
                                            Download
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                    :""}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    </div>
                    <a
                      ref={downloadLinkRef}
                      style={{ display: "none" }}
                      href={() => false}
                    ></a>
                  </Col>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="container mt-4">
              <div className="row justify-content-center">
                <div className="col-6">
                  <div className="card">
                    <div className="card-body text-center font-weight-bold">
                      No Stakeholder Submitted
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Stakeholder;
